const TOKEN_KEY = 'at.ug.token';

class TokenStorage {
    set = (token: string) => localStorage.setItem(TOKEN_KEY, token);
    get = () => localStorage.getItem(TOKEN_KEY);
    clear = () => localStorage.removeItem(TOKEN_KEY);
}

export const tokenStorage = new TokenStorage();
